import styled from 'styled-components';
import { Modal } from '@jjj/components';
import { palette } from 'styled-theme';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 24px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 40px 32px 0;
    border-bottom: none;

    .ant-modal-title {
      font-size: 24px;
      font-weight: 700;
      line-height: 1.25;
      color: ${palette('grayscale', 0)};
      text-align: left;
    }
  }

  .ant-modal-body {
    padding: 12px 32px 20px;
  }

  .ant-modal-footer {
    border-top: 1px solid ${palette('border', 0)};
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end;
  }
`;

export const ModalDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${palette('text', 1)};
  margin: 0 0 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const CheckboxWrapper = styled.div`
  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
  }

  .ant-checkbox {
    top: 0;
  }
`;
